import { ItemTypeConsts, ItemTypeDisplayNames } from 'client/util/Constants';

/**
 * DO NOT ADD TO THIS LIST OF EVENTS
 * legacyEvents are just that. We do not want to add to this list.
 * New events should follow the JC Segment Events Framework
 */
export const legacyEvents = {
  // AD Sync events
  adDownloadImportAgentInstallerClicked: 'AD Download Import Agent Installer Clicked',
  adDownloadSyncAgentInstallerClicked: 'AD Download Sync Agent Installer Clicked',

  // "Add" button click events
  addNewApplicationButtonClicked: 'Add New Application Button Clicked',
  addNewCommandButtonClicked: 'Add New Command Button Clicked',
  addNewDeviceButtonClicked: 'Add New Device Button Clicked',
  addNewDirectoryButtonClicked: 'Add New Directory Button Clicked',
  addNewDirectoryTypeSelected: 'Add New Directory Type Selected',
  addNewGroupButtonClicked: 'Add New Group Button Clicked',
  addNewLdapButtonClicked: 'Add New LDAP Button Clicked',
  addNewPolicyButtonClicked: 'Add New Policy Button Clicked',
  addNewRadiusServerButtonClicked: 'Add New RADIUS Server Button Clicked',
  addNewSystemButtonClicked: 'Add New System Button Clicked',
  addNewUserButtonClicked: 'Add New User Button Clicked',
  addNewUserFromCSVButtonClicked: 'Add New User From CSV Button Clicked',
  addResourceDropDownItemClicked: 'Add Resource Dropdown Item Clicked',
  addUsersFromGSuiteButtonClicked: `Add Users From ${ItemTypeDisplayNames[ItemTypeConsts.gSuite]} Button Clicked`,
  addUsersFromO365ButtonClicked: `Add Users From ${ItemTypeDisplayNames[ItemTypeConsts.office365]} Button Clicked`,
  addUserToUserGroupButtonClicked: 'Add User to User Group Button Clicked',
  connectUserToDeviceButtonClicked: 'Connect User to Device Button Clicked',

  // Admin events
  adminDropdownButtonClicked: 'Administrators Dropdown Button Clicked',
  administratorSaved: 'Administrator Saved',
  adminResendEmail: 'Administrator Email Re-sent',
  editAdminInformation: 'Administrator Updated',
  addNewAdminButtonClicked: 'Add New Admin Button Clicked',
  createNewAdminModalCanceled: 'Create New Admin Modal Canceled',
  administratorsModalClosed: 'Administrators Modal Closed',

  // System insights events
  systemInsightsView: 'System Insights View',

  // Aside Panel events
  copyWellClicked: 'Copy Well Clicked',
  directoryImportUsersLinkClicked: 'Directory Import Users Link Clicked',
  ldapAsidePanelVisited: 'LDAP Aside Panel Visited',
  softwareManagementAsidePanelVisited: 'Software Management Aside Panel Visited',

  // Attribute Driven Groups events
  membershipSuggestionsButtonClicked: 'Membership Suggestions Button Clicked',
  membershipSuggestionsLinkClicked: 'Membership Suggestions Link Clicked',
  membershipSuggestionsModalClosed: 'Membership Suggestions Modal Closed',

  // Banner Events
  bannerLinkClicked: 'Banner Link Clicked',
  applicationBannerCheckItOutButtonClicked: 'Application Banner Check It Out Button Clicked',
  applicationBannerLearnMoreButtonClicked: 'Application Banner Learn More Button Clicked',

  // Chat events
  chatPopoverDismissed: 'Chat Popover Closed',
  chatPopoverCtaClicked: 'Chat Opened from Popover',

  // FAQ events
  faqClicked: 'FAQ clicked',

  // Collapsable Section (GetStartedInstructions)
  collapsableSectionLinkClicked: 'Collapsable Section Link Clicked',
  collapsableSectionButtonClicked: 'Collapsable Section Button Clicked',
  collapsableSectionControlEvent: 'Collapsable Section Control Event',

  // Devices new requirements Policies
  deviceMacPolicies: 'Device new requirements macOS Policies',

  // Directory events
  authorizeSyncClicked: 'Authorize Directory Sync Clicked',
  deactivateSyncClicked: 'Deactivate Directory Sync Clicked',
  deactivateSyncConfirmed: 'Deactivate Directory Sync Confirmed',
  reactivateSyncClicked: 'Reactivate Directory Sync Clicked',

  // "Disable System Insights" modal in settings panel
  disableSystemInsightsModalCanceled: 'Disable System Insights Modal Canceled',
  disableSystemInsightsModalViewed: 'Disable System Insights Modal Viewed',

  // "Enable System Insights" modal in settings panel
  enableSystemInsightsKbLinkClicked: 'Enable System Insights KB Link Clicked',
  enableSystemInsightsModalCanceled: 'Enable System Insights Modal Canceled',
  enableSystemInsightsModalViewed: 'Enable System Insights Modal Viewed',

  // Experiment Events
  experimentVariationMismatch: 'Experiment Variation Mismatch',

  // Enable/Disable User Portal System Install events
  userPortalSystemAgentInstall: 'Toggle User Portal System Agent install Clicked',

  // Getting Started panel events
  gettingStartedHowItWorksModalDismissed: 'Getting Started How It Works Modal Dismissed',
  gettingStartedHowItWorksModalViewed: 'Getting Started How It Works Modal Viewed',
  gettingStartedPageButtonClicked: 'Getting Started Page Button Clicked',
  gettingStartedPageLinkClicked: 'Getting Started Page Link Clicked',

  // Getting Started popover events
  gettingStartedPopoverDismissed: 'Getting Started Popover Dismissed',
  gettingStartedPopoverLetsGoButtonClicked: 'Getting Started Popover Let\'s Go Button Clicked',

  // Getting Started protip events
  gettingStartedLdapProtipLearnMoreClicked: 'Getting Started Ldap Protip Learn More Clicked',

  // Groups Getting Started main panel
  groupsGettingStartedModalDismissed: 'Groups Getting Started Modal Dismissed',
  groupsGettingStartedModalViewed: 'Groups Getting Started Modal Viewed',

  // Header events
  pricingButtonClicked: 'Pricing Button Clicked',

  // Home panel events
  homePageLinkClicked: 'Insights Homepage Link Clicked',
  homePageManageHomeLinkClicked: 'Insights Homepage Manage Home Link Clicked',
  homePageManageToggleClicked: 'Insights Homepage Manage Home Toggle Clicked',

  // Home widget events
  homeWidgetActionButtonClicked: 'Home Widget Action Button Clicked',
  homeWidgetHideClicked: 'Home Widget Hide Widgets Icon Clicked',
  homeWidgetIndividualItemClicked: 'Home Widget Individual Item Clicked',

  // Import events
  bulkImportUsersInitiated: 'Bulk Import Users Initiated',
  importUsersComplete: 'Import Users Complete',

  // Insights panel events
  activityLogColumnsChanged: 'Activity Log Columns Changed',
  activityLogDateRangeChanged: 'Activity Log Date Range Changed',
  activityLogExported: 'Activity Log Exported',
  activityLogFilterChanged: 'Activity Log Filter Changed',
  activityLogFilterOptionsLoaded: 'Activity Log Filter Options Loaded',
  triggerActivityLogFilterTemplateSelected: 'Activity Log Filter Template Selected',
  activityLogTableCellValueClicked: 'Activity Log Table Cell Value Clicked',
  insightsPaywallViewed: 'Insights Paywall Viewed',
  insightsPaywallEmailClicked: 'Insights Paywall Email Link Clicked',
  insightsPaywallPricingClicked: 'Insights Paywall Pricing Link Clicked',
  insightsVideoPlayed: 'Directory Insights Video Played',

  // Item addition events
  applicationAdded: 'Application Added',
  commandAdded: 'Command Added',
  directoryAdded: 'Directory Added',
  groupAdded: 'Group Added',
  ldapAdded: 'LDAP Resource Added',
  policyAdded: 'Policy Added',
  radiusAdded: 'RADIUS Server Added',
  resourceAdded: 'Resource Added',
  managedSoftwareAdded: 'Managed Software Added',
  systemAdded: 'System Added',
  systemGroupAdded: 'System Group Added',
  userAdded: 'User Added',
  userGroupAdded: 'User Group Added',

  // Item binding events
  userBoundToUserGroup: 'User Bound To User Group',

  // Item table events
  itemTableExported: 'Item Table Exported',

  // Legacy Router events
  legacyPageRedirect: 'Legacy Page Redirect',
  legacyRouterPathVisited: 'Legacy Router Path Visited',

  // Login and Logout events
  logOutClicked: 'Log Out Clicked',
  signInWithGoogleClicked: 'Sign In With Google Clicked',

  // MDM events
  mdmButtonClicked: 'Button on MDM page clicked',
  mdmChecklistItemClicked: 'MDM Configure page: checklist content clicked',
  mdmHomeVideoPlayed: 'MDM Home Video Played',

  // Mobile Signup Notification events
  notOptimizedForMobileModalViewed: 'Not Optimized For Mobile Modal Viewed',
  continueWithMobileLinkClicked: 'Continue With Mobile Link Clicked',

  // ModalFooter events
  modalFooterKbLinkClicked: 'KB Link In Modal Footer Clicked',

  // MTP metrics
  adminConsoleLaunched: 'Admin Console Launched',
  orgDetailExpanded: 'Organization Detail Expanded',
  addOrgModalOpened: 'Add Organization Modal Opened',
  newOrgAdded: 'New Organization Added',
  addMTPAdminPageOpened: 'Add MTP Administrator Page Opened',
  newMTPAdminAdded: 'New MTP Administrator Added',
  adminStatusChange: 'Admin Status Change',

  // Navigation
  navItemClicked: 'Nav Item Clicked',
  navPanelCollapsed: 'Nav Panel Collapsed',
  navMenuItemClicked: 'Nav Menu Option Clicked',

  // Onboarding checklist events
  gettingStartedLearningCenterLinkClicked: 'Getting Started Learning Center Link Clicked',
  gettingStartedRequestDemoButtonClicked: 'Getting Started Request Demo Button Clicked',
  onboardingChecklistCompleted: 'Onboarding Checklist Completed',
  onboardingChecklistModalAddSystemsInBulkLinkClicked: 'Onboarding Checklist Modal Add Systems In Bulk Link Clicked',
  onboardingChecklistTaskCompleted: 'Onboarding Checklist Task Completed',
  onboardingVideoClicked: 'Onboarding Video Clicked',
  resourceDeepLinkClicked: 'Resource Deep Link Clicked',
  systemSetupModalDismissed: 'System Setup Modal Dismissed',
  systemSetupModalViewed: 'System Setup Modal Viewed',

  // Page visits
  applicationsPageVisited: 'Applications Page Visited',
  commandsPageVisited: 'Commands Page Visited',
  directoriesPageVisited: 'Directories Page Visited',
  groupsPageVisited: 'Groups Page Visited',
  ldapPageVisited: 'LDAP Page Visited',
  insightsPageVisited: 'Insights Page Visited',
  insightsHomePageVisited: 'Insights Homepage Visited',
  mdmPageVisited: 'MDM Page Visited',
  notificationsPageVisited: 'Notifications Page Visited',
  policiesPageVisited: 'Policies Page Visited',
  radiusPageVisited: 'RADIUS Page Visited',
  reportsPageVisited: 'Reports Page Visited',
  settingsPageVisited: 'Settings Page Visited',
  supportPageVisited: 'Support Page Visited',
  systemsPageVisited: 'Systems Page Visited',
  usersPageVisited: 'Users Page Visited',

  // Payment events
  paymentChatClicked: 'Payment Chat Clicked',
  calendlyLinkClicked: 'Calendly Link Clicked',
  contactSalesButtonClicked: 'Contact Sales Button Clicked',
  emailSalesLinkClicked: 'Email Sales Link Clicked',
  paymentModalViewed: 'Payment Modal Viewed',
  paymentModalDismissed: 'Payment Modal Dismissed',
  paymentInfoSubmitted: 'Payment Info Submitted',
  paymentLinkClicked: 'Payment Link Clicked',
  enterCreditCardButtonClicked: 'Enter a Credit Card button Clicked',

  // Product Tour events
  productTourLaunchButtonClicked: 'Product Tour Launch Button Clicked',
  progressDotsClicked: 'Progress Dots Clicked',

  // RADIUS Events
  newRadiusSaveServerClicked: 'Getting Started RADIUS new server saved',
  radiusGettingStartedLearnMoreClicked: 'Getting Started RADIUS Learn More clicked',

  // Resources panel events
  resourcesKnowledgeSearched: 'Resources Knowledge Base Searched',
  resourcesOfficeHoursClicked: 'Resources - Office Hours Clicked',
  resourcesPanelOpened: 'Resources Panel Opened',
  resourcesPanelClosed: 'Resources Panel Closed',
  resourcesSlackLoungeClicked: 'Resources - Slack Lounge Clicked',
  resourcesSupportPanelOpened: 'Resources - Support Panel Opened',
  resourcesVideoTutorialsClicked: 'Resources - Video Tutorials Clicked',
  resourcesWhatsNewReadMoreLinkClicked: 'Resources - What\'s New Read More Link Clicked',

  // Recommended Items events
  recommendedCommandClicked: 'Recommended Command Clicked',

  // Reports page events
  reportExported: 'Report Exported',
  reportTypeVisited: 'Report Type Visited',

  // Segment Data Mapping events
  segmentUserIdMapping: 'Segment User ID Mapping',

  // Signup events
  signupQuestionAnswered: 'Signup Question Answered',
  signupQuestionConfirmationModalClicked: 'Signup Question Confirmation Modal Clicked',

  // System Collapsable Section events
  systemTerminalSectionCollapsed: 'System Collapsable Section Collapsed',
  systemTerminalSectionExpanded: 'System Collapsable Section Expanded',

  // System Insights events
  systemInsightsTableSelected: 'System Insights Table Selected',
  systemInsightsExportClicked: 'System Insights Export Clicked',

  // System support pages
  systemSupportLinkClicked: 'System Additional Information Link Clicked',

  // System tab events
  systemTabClicked: 'System Tab Clicked',
  systemAccordionClicked: 'System Accordion Section Clicked',

  // Submit Feature Idea modal
  submitIdea: 'Feature Idea Submitted',

  // Support page/contact events
  contactSupportClicked: 'Contact Support Clicked',
  submitSupportTicketKbLinkClicked: 'Submit Support Ticket KB Link Clicked',
  talkToSpecialistLinkClicked: 'Talk To Specialist Link Clicked',
  webinarLinkClicked: 'Webinar Link Clicked',
  outreachLinkClicked: 'Outreach.io Link Clicked',

  // System events
  compatibilityNotesExpanded: 'System Compatibility Notes Expanded',
  compatibilityNotesCollapsed: 'System Compatibility Notes Collapsed',
  compatibilityNotesLearnMoreClicked: 'System Compatibility Learn More HyperLink Clicked',
  systemAcknowledged: 'New Unbound System Acknowledged',
  systemBound: 'User Installed System Bound Via Systems Page',
  systemsDownloadAgentButtonClicked: 'Systems Aside Panel Download Agent Clicked',
  systemGetAgentLogClicked: 'Get System Logs Clicked',
  systemDownloadAgentLogClicked: 'Download System Logs Clicked',

  // User Details events
  localUserAccountModalClicked: 'Local User Account button clicked',

  // Video modal events
  videoModalLinkClicked: 'Video Modal Link Clicked',

  // Ways To Add System User events
  waysToAddSystemUserLearnMoreClicked: 'Ways to Add System User Learn More resource clicked',

  // Ways To Add Device events
  waysToAddDeviceLearnMoreClicked: 'Ways to Add Device Learn More resource clicked',

  // Welcome modal events
  welcomeModalConfirmationClicked: 'Welcome Modal Confirmation Clicked',
  welcomeModalDismissed: 'Welcome Modal Dismissed',
  welcomeModalVideoPlayed: 'Welcome Modal Video Played',
};

export default {
  legacyEvents,
};
